import { Select, Slider } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../redux';
import { boardSelector, setCanvasDrawingMode, setDrawingToolOpen, setDrawingValues } from '../../redux/board/reducer';
import { BRUSH_MODE, DEFAULT_BRUSH, DRAWING_TOOLS, eventBus } from '../../utils';
import SettingForm from '../SettingForm';
import './styles.scss';

const { Option } = Select;

const HandleDrawingTool = () => {
  const dispatch = useDispatch();
  const { isDrawingToolOpen } = useSelector(boardSelector);
  const [value, setValue] = useState(DEFAULT_BRUSH);

  const onClose = () => {
    dispatch(setCanvasDrawingMode(false));
    dispatch(setDrawingToolOpen(false));
    dispatch(setDrawingValues(DEFAULT_BRUSH));
    setValue(DEFAULT_BRUSH);
  };

  useEffect(() => {
    eventBus.on('on-drawing-done', onClose);
    return () => {
      eventBus.off('on-drawing-done', onClose);
    };
  }, [value]);
  useEffect(() => {
    if (!isDrawingToolOpen) {
      setValue(DEFAULT_BRUSH);
    }
  }, [isDrawingToolOpen]);

  const onChange = (e, item) => {
    let result = value;
    switch (item.type) {
      case 'select':
        result = {
          ...value,
          [item.action]: e,
        };
        break;
      case 'range':
        result = {
          ...value,
          [item.action]: e,
        };
        break;
      default:
        result = {
          ...value,
          [item.action]: e.target.value,
        };
        break;
    }
    setValue(result);
    dispatch(actions.setDrawingValue(result));
  };

  const renderForm = (item) => {
    switch (item.type) {
      case 'select':
        return (
          <div>
            <div>{`${item.label}:`}</div>
            <div>
              <Select
                onChange={(e) => onChange(e, item)}
                className="select-form"
                value={(value && value.mode) || undefined}
                defaultValue="Pencil"
              >
                {BRUSH_MODE.map((i, index) => (
                  <Option key={index} value={i.value}>
                    <div>{i.label}</div>
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        );
      case 'range':
        return (
          <div>
            <div>{`${item.label}:`}</div>
            <div>
              <Slider
                className="slider"
                value={value ? value[item.action] : undefined}
                min={parseInt(item.min) || 0}
                max={parseInt(item.max) || 100}
                step={parseInt(item.step) || 1}
                defaultValue={DEFAULT_BRUSH[item.action]}
                onChange={(e) => onChange(e, item)}
              />
            </div>
          </div>
        );
      default:
        return (
          <SettingForm
            isblock="true"
            type={item.type}
            title={item.label}
            textTitle={item.label}
            onChange={(e) => onChange(e, item)}
            value={value ? value[item.action] : undefined}
            defaultValue={DEFAULT_BRUSH[item.action]}
            {...(item.min ? { min: item.min } : {})}
            {...(item.max ? { max: item.max } : {})}
            {...(item.step ? { step: item.step } : {})}
          />
        );
    }
  };

  return (
    <>
      {isDrawingToolOpen ? (
        <div className="hanlde-draw-toolbar">
          <div className="mo-editor__drawing-items">
            {DRAWING_TOOLS.map((item, index) => (
              <div key={index} className="item">
                {renderForm(item)}
              </div>
            ))}
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default HandleDrawingTool;
